import React, { useEffect, useState } from "react";

import {
  Box,
  Button,
  FormControl,
  Select,
  Checkbox,
  ListItemText,
  Chip,
  CircularProgress,
  Grid,
  Menu,
  MenuItem,
  Stack,
  styled,
  TextField,
  Typography,
  Paper,
  TableHead,
  TableRow,
  TableCell,
  Table,
  TableBody,
  TablePagination,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import { DataGrid } from "@mui/x-data-grid";
import { useNavigate } from "react-router-dom";
import { useGetTokenOrLogout } from "../../../utils/token";
import HeadingCard from "../../newComponent/NewCardsComp/HeadingCard";
import CustomAutocompleteComp from "../../newComponent/AutocompleteComp";
import SearchButton from "../../newComponent/NewButtonComp/SearchButton";
import StyledTableContainer from "../../newComponent/TableContainer";
import ClearButtonComp from "../../newComponent/NewButtonComp/ResetButtonComp";
import MainCard from "../../../components/Maincard";
import CustomSnackbar from "../../components/ui-component/snackbar/CustomSnackbar";
import LoaderComp from "../../newComponent/LoaderComp/Loader";

export default function TeamReport() {
  const navigate = useNavigate();
  const userId = localStorage.getItem("userId");

  const getTokenOrLogout = useGetTokenOrLogout();
  const ITEM_HEIGHT = 48;
  const ITEM_PADDING_TOP = 8;
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 250,
      },
    },
  };
  const API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT;
  const [branchlist, setBranchlist] = useState([]);
  const [branch, setBranch] = useState([]);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [snackbarOpen, setSnackbarOpen] = React.useState(false);
  const [snackbarMessage, setSnackbarMessage] = React.useState("");
  const [snackbarSeverity, setSnackbarSeverity] = React.useState("success");
  const showSnackbar = (message, severity) => {
    setSnackbarMessage(message);
    setSnackbarSeverity(severity);
    setSnackbarOpen(true);
  };
  // Pagination
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(`${API_ENDPOINT}branch`);
        if (response.ok) {
          const data = await response.json();

          setBranchlist(data);
        } else {
          throw new Error(`Request failed with status: ${response.status}`);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);

  const allbranchList = [{ branch_name: "Select All" }, ...branchlist];
  const handelbranchchange = (event, value) => {
    if (value.some((option) => option.branch_name === "Select All")) {
      setBranch(branchlist);
    } else {
      setBranch(value);
    }
  };

  useEffect(() => {
    const token = getTokenOrLogout();
    console.log("token", token);
    if (!token) return;
    let headers = {
      Authorization: `Bearer ${token}`,
    };

    setLoading(true);
    const fetchData = async () => {
      try {
        const response = await fetch(
          ` ${API_ENDPOINT}teamleadapis/fetchteammembers/${userId}`,
          { headers }
        );
        if (response.ok) {
          const data = await response.json();
          setData(data);

          setLoading(false);
        } else if ((response.status = 400)) {
          showSnackbar("User id is null or undefined", "error");
          setLoading(false);
        } else if ((response.status = 401)) {
          showSnackbar("User is not found", "error");
          setLoading(false);
        } else if ((response.status = 403)) {
          showSnackbar("Unauthorised user", "error");
          setLoading(false);
        } else if ((response.status = 404)) {
          showSnackbar("No team members found", "error");
          setLoading(false);
        } else {
          showSnackbar("Server Error", "error");
          setLoading(false);
          throw new Error(`Request failed with status: ${response.status}`);
        }
      } catch (error) {
        showSnackbar("Server Error", "error");
        setLoading(false);
      }
    };

    fetchData();
  }, [userId]);

  // const handleclick = (row) => {
  //   const url = `/advisorrevenue/${row.user_id}`;
  //   const newTab = window.open(url, "_blank");
  //   if (newTab) {
  //     newTab.focus();
  //   }
  // };

const handleclick = (row) => {
  localStorage.setItem("countryid", JSON.stringify({
    countryName: row?.country_id
  }));

  const newTab = window.open(`/advisorrevenue/${row.user_id}`, "_blank");
  if (newTab) {
    newTab.focus();
  }
};





  const handleReset = () => {
    setData([]);
    setBranch([]);
  };

  return (
    <>
      <LoaderComp isLoading={loading} />
      <Grid container spacing={2}>
        <Grid item xs={12} sm={5} md={4} lg={3}>
          <HeadingCard label="Team Member Report" />
        </Grid>
        {/* <Grid item xs={12}>
          <MainCard>
            <Grid container spacing={3}>
              <Grid item xs={12} lg={6}>
                <FormControl sx={{ mb: 1, width: "100%" }}>
                  <Typography variant="h6"> Center / Branch</Typography>

                  <CustomAutocompleteComp
                    size="small"
                    value={branch}
                    multiple
                    onChange={handelbranchchange}
                    options={allbranchList}
                    getOptionLabel={(option) => option.branch_name}
                    tooltipContent={(option) => option.branch_name}
                    placeholder="Please Select Branches"
                  />
                </FormControl>
              </Grid>

              <Grid item xs={4} lg={6} mt={2} container gap={1}>
                <SearchButton
                  size="small"
                  showIcon={true}
                  onClick={handleSearch}
                />

                <ClearButtonComp size="small" onClick={handleReset} />
              </Grid>
            </Grid>
          </MainCard>
        </Grid> */}

        <Grid item xs={12}>
          <MainCard>
            {loading ? (
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <CircularProgress />
              </Box>
            ) : data?.length === 0 ? (
              <Grid
                item
                xs={12}
                style={{
                  display: "flex",
                  justifyContent: "start",
                  alignItems: "center",
                }}
              >
                <Typography variant="h5">No data available</Typography>
              </Grid>
            ) : (
              <StyledTableContainer component={Paper} borderLeft={true}>
                <Table
                  sx={{ minWidth: 650, tableLayout: "fixed" }}
                  aria-label="simple table"
                  stickyHeader
                >
                  <TableHead>
                    <TableRow>
                      <TableCell>Team Member Name</TableCell>
                      <TableCell>Branch</TableCell>
                    </TableRow>
                  </TableHead>

                  {data
                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map((row, index) => (
                      <TableBody>
                        <TableRow
                          key={row.name}
                          style={{
                            backgroundColor:
                              index % 2 === 0 ? "#f0f0f0" : "inherit",
                          }}
                        >
                          <TableCell sx={{ borderLeft: "0.1px solid #C3C3C3" }}>
                            <Box
                              color="#2f96f5"
                              sx={{ cursor: "pointer" }}
                              onClick={() => handleclick(row)}
                            >
                              {" "}
                              {row?.first_name} {row?.last_name}
                            </Box>
                          </TableCell>
                          <TableCell>{row?.branch?.branch_name}</TableCell>
                        </TableRow>
                      </TableBody>
                    ))}
                </Table>
                <TablePagination
                  rowsPerPageOptions={[5, 10, 25]}
                  component="div"
                  count={data.length}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                />
              </StyledTableContainer>
            )}
          </MainCard>
        </Grid>
      </Grid>
      <CustomSnackbar
        open={snackbarOpen}
        onClose={() => setSnackbarOpen(false)}
        message={snackbarMessage}
        severity={snackbarSeverity}
      />
    </>
  );
}
